import { render, staticRenderFns } from "./Socialsignup.vue?vue&type=template&id=51b97b0e&scoped=true&"
import script from "./Socialsignup.vue?vue&type=script&lang=js&"
export * from "./Socialsignup.vue?vue&type=script&lang=js&"
import style0 from "./Socialsignup.vue?vue&type=style&index=0&id=51b97b0e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51b97b0e",
  null
  
)

export default component.exports